<div class="ra-modal">
  <!-- Header -->
  <div class="ra-modal__header">
    <div>
      <p class="ra-modal__step-label">NEW REPORT · STEP {{ step }} OF {{ stepTotal }}</p>
      <h2 class="ra-modal__title">{{ stepTitle }}</h2>
    </div>
    <button type="button" class="ra-modal__close-btn" (click)="close()">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  </div>

  <!-- Progress dots -->
  <div class="ra-modal__progress">
    <span class="ra-modal__dot" [class.ra-modal__dot--active]="step >= 1"></span>
    <span class="ra-modal__dot" [class.ra-modal__dot--active]="step >= 2"></span>
    <span *ngIf="typeHasFilters" class="ra-modal__dot" [class.ra-modal__dot--active]="step >= 3"></span>
  </div>

  <!-- Body -->
  <div class="ra-modal__body" (click)="onBodyClick($event)">

    <!-- STEP 1: Report type -->
    <ng-container *ngIf="step === 1">
      <p class="ra-modal__hint">Choose the report you want to generate. Each type pulls from real Snowflake catalogs.</p>
      <div *ngIf="loadingReportTypes" class="ra-modal__type-loading">
        <span class="ra-table-card__spinner"></span>
      </div>
      <div *ngIf="!loadingReportTypes" class="ra-modal__type-list">
        <button
          *ngFor="let t of reportTypes"
          type="button"
          class="ra-modal__type-card"
          [class.ra-modal__type-card--selected]="form.type === t.name"
          (click)="form.type = t.name"
        >
          <span class="ra-modal__type-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <path d="M5 21V5a2 2 0 0 1 2-2h7l5 5v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
              <path d="M14 3v4a1 1 0 0 0 1 1h4" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
            </svg>
          </span>
          <span class="ra-modal__type-text">
            <span class="ra-modal__type-name">{{ t.name }}</span>
          </span>
          <span class="ra-modal__radio" [class.ra-modal__radio--selected]="form.type === t.name">
            <span class="ra-modal__radio-dot"></span>
          </span>
        </button>
      </div>
    </ng-container>

    <!-- STEP 2: Base fields -->
    <ng-container *ngIf="step === 2">
      <p class="ra-modal__hint">Select values from the catalog. Type to search inside any field.</p>
      <div class="ra-modal__fields">
        <one-select
          label="maker"
          [dataSource]="makersDataSource"
          [config]="makerSelectConfig"
          (selectionChanged)="onMakerChange($event)"
        ></one-select>

        <div class="ra-modal__fields-group">
          <div class="ra-modal__fields-group-label">Pay period (end date)</div>
          <div class="ra-modal__fields-row">
            <div class="ra-modal__fields-group">
              <span class="ra-modal__axis-label">Pay month <span class="ra-modal__required">*</span></span>
              <one-select
                label="Month…"
                [dataSource]="monthOptions"
                [config]="simpleSelectConfig"
                [value]="selectedMonth"
                (selectionChanged)="onMonthChange($event)"
              ></one-select>
            </div>

            <div class="ra-modal__fields-group">
              <span class="ra-modal__axis-label">Pay year <span class="ra-modal__required">*</span></span>
              <one-select
                label="Year…"
                [dataSource]="yearOptions"
                [config]="simpleSelectConfig"
                [value]="selectedYear"
                (selectionChanged)="onYearChange($event)"
              ></one-select>
            </div>
          </div>
        </div>

        <div *ngIf="!isCampaignReport" class="ra-modal__fields-group">
          <div class="ra-modal__fields-group-label">Start period (start date) — optional</div>
          <div class="ra-modal__fields-row">
            <div class="ra-modal__fields-group">
              <span class="ra-modal__axis-label">Start month</span>
              <one-select
                label="Month…"
                [dataSource]="monthOptions"
                [config]="simpleSelectConfig"
                [value]="selectedStartMonth"
                (selectionChanged)="onStartMonthChange($event)"
              ></one-select>
            </div>

            <div class="ra-modal__fields-group">
              <span class="ra-modal__axis-label">Start year</span>
              <one-select
                label="Year…"
                [dataSource]="yearOptions"
                [config]="simpleSelectConfig"
                [value]="selectedStartYear"
                (selectionChanged)="onStartYearChange($event)"
              ></one-select>
            </div>
          </div>
          <p *ngIf="!startPeriodValid" class="ra-modal__field-error">Both month and year are required together.</p>
        </div>

        <div class="ra-modal__fields-group">
          <span class="ra-modal__axis-label">Language <span class="ra-modal__required">*</span></span>
          <one-select
            label="Select…"
            [dataSource]="languageOptions"
            [config]="simpleSelectConfig"
            [value]="selectedLanguage"
            (selectionChanged)="onLanguageChange($event)"
          ></one-select>
        </div>

        <div *ngIf="isCampaignReport" class="ra-modal__text-field">
          <label class="ra-modal__text-field-label">
            Campaign tag <span class="ra-modal__required">*</span>
          </label>
          <input
            type="text"
            class="ra-modal__text-field-input"
            placeholder="e.g. PSCo_JBP-Nov/25_BlackFriday"
            [value]="form.campaignTag"
            (input)="form.campaignTag = $event.target.value"
          />
        </div>
      </div>
    </ng-container>

    <!-- STEP 3: Optional filters -->
    <ng-container *ngIf="step === 3">
      <div class="ra-modal__optional-badge">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8"/>
          <path d="M12 11v5M12 8h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        All filters are optional — only fill in what you need.
      </div>
      <div class="ra-modal__fields">
        <div class="ra-modal__fields-group">
          <span class="ra-modal__axis-label">Trademark</span>
          <one-select
            label="All trademarks"
            [dataSource]="trademarkEntities"
            [config]="simpleSelectConfig"
            [value]="selectedTrademark"
            [disabled]="loadingTrademarks || !form.maker"
            (selectionChanged)="onTrademarkChange($event)"
          ></one-select>
        </div>

        <div class="ra-modal__axis-group">
          <span class="ra-modal__axis-label">Segmentation axis</span>
          <div class="ra-modal__axis-tabs">
            <button
              *ngFor="let ax of axisList"
              type="button"
              class="ra-modal__axis-tab"
              [class.ra-modal__axis-tab--active]="form.axis === ax.key"
              (click)="onAxisChange(ax.key)"
            >{{ ax.label }}</button>
          </div>

          <p *ngIf="form.axis && !form.trademark" class="ra-modal__axis-hint">Select a Trademark above to load {{ form.axis }} options.</p>

          <ng-container *ngIf="form.axis === 'segment' && form.trademark">
            <p class="ra-modal__axis-hint">Segment values are scoped to a Category — select one to load them.</p>
            <one-select
              label="Select a category…"
              [dataSource]="subcategoryEntities"
              [config]="simpleSelectConfig"
              [value]="selectedAxisSubcategory"
              [disabled]="loadingSubcategories"
              (selectionChanged)="onAxisSubcategoryChange($event)"
            ></one-select>
          </ng-container>

          <one-select
            *ngIf="form.axis && axisValueReady"
            [label]="activeAxisPlaceholder"
            [dataSource]="activeAxisEntities"
            [config]="simpleSelectConfig"
            [value]="selectedAxisValue"
            [disabled]="activeAxisLoading"
            (selectionChanged)="onAxisValueChange($event)"
          ></one-select>
          <p *ngIf="!form.axis" class="ra-modal__axis-hint">Choose an axis to filter by a specific value.</p>
        </div>

        <div class="ra-modal__fields-group">
          <span class="ra-modal__axis-label">Retailer</span>
          <div class="ra-modal__clearable-select">
          <one-select
            label="All retailers"
            [dataSource]="retailersDataSource"
            [config]="retailerSelectConfig"
            (selectionChanged)="onRetailerChange($event)"
          ></one-select>
          <button
            *ngIf="selectedRetailer"
            type="button"
            class="ra-modal__clearable-select-btn"
            title="Clear"
            (click)="clearRetailer()"
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
          </div>
        </div>

        <div class="ra-modal__fields-group">
          <span class="ra-modal__axis-label">Vertical</span>
          <one-select
            label="All verticals"
            [dataSource]="verticalEntities"
            [config]="simpleSelectConfig"
            [value]="selectedVertical"
            [disabled]="loadingVerticals"
            (selectionChanged)="onVerticalChange($event)"
          ></one-select>
        </div>
      </div>
    </ng-container>

  </div>

  <!-- Footer -->
  <div class="ra-modal__footer">
    <span class="ra-modal__format-hint">
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
        <path d="M14 3v4a1 1 0 0 0 1 1h4" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
        <path d="M5 21V5a2 2 0 0 1 2-2h7l5 5v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/>
      </svg>
      Output format: PPTX
    </span>

    <button *ngIf="canGoBack" type="button" class="ra-modal__btn ra-modal__btn--secondary" (click)="back()">Back</button>

    <button
      *ngIf="showNext"
      type="button"
      class="ra-modal__btn ra-modal__btn--primary"
      [disabled]="!nextEnabled"
      (click)="next()"
    >Next</button>

    <button
      *ngIf="showGenerate"
      type="button"
      class="ra-modal__btn ra-modal__btn--primary"
      [disabled]="!generateEnabled || submitting"
      (click)="submit()"
    >{{ submitting ? 'Generating…' : 'Generate report' }}</button>
  </div>
</div>
